import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  copied?: boolean
}

export const Container = styled.button`
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;

  gap: 8px;

  .copied {
    color: var(--cinza-7-cinza-novo-75, #757575);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 250% */
  }

  .copy-icon {
    width: 24px;
    height: 24px;

    filter: ${(props: IStyleProps) => {
      if (props.copied) return ''
      return ''
    }};
  }
`
